<template>
  <div>
    <NuxtLink to="#overview">
      <h2 id="overview"><DocsIconClipboard /> Overview</h2>
    </NuxtLink>
    <div>
      <p>
        Otago is a custom server for expo-updates library. When the SDK is installed on your mobile application, each
        time a user starts the app, it will check on Otago for updates. If there is a new version, it is downloaded and
        installed.
      </p>
      <img src="/images/docs/global-architecture.png" alt="Global architecture" class="mt-6 w-full max-w-lg" />

      <ul class="mt-6 mb-4">
        <li><span class="text-green-400">✓ Can be updated:</span> Javascript code, images, fonts...</li>
        <li>
          <span class="text-red-500">✗ Cannot be updated:</span> Native code, app config, libraries that import native
          code...
        </li>
      </ul>
    </div>

    <NuxtLink to="#overview-architecture">
      <h3 id="overview-architecture">Architecture</h3>
    </NuxtLink>
    <div>
      <div>
        Otago is composed of 4 main parts:
        <ul class="mt-2 list-disc list-inside">
          <li>CLI: to help you bundle and sign your update, then send the assets.</li>
          <li>Dashboard: manage your apps, settings, and billing.</li>
          <li>Deploy: a light replicable service to serve your manifests.</li>
          <li>CDN: serves your assets (currently Cloudflare R2).</li>
        </ul>
      </div>
      <img src="/images/docs/otago-architecture.png" alt="Otago architecture" class="mt-6 w-full max-w-3xl" />
    </div>
  </div>
</template>
